import { PropsWithChildren } from 'lib-shared-types-utils';

import { AppLink } from 'components/appLink';

export type QueueLinkProps = {
  /** The id of the queue used to link to the conversations page */
  queueId: string;
} & PropsWithChildren;

export const QueueLink = ({
  queueId,
  children,
}: QueueLinkProps): JSX.Element => (
  <AppLink
    path={`/conversations`}
    params={{ search: { queue: [queueId], status: ['open', 'pending'] } }}
  >
    {children}
  </AppLink>
);
